/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Manager_Inventory_LinkInputs */

const vi_dashboard_manager_inventory_link = /** @type {(inputs: Dashboard_Manager_Inventory_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem chi tiết tồn kho`)
};

/**

* @param {Dashboard_Manager_Inventory_LinkInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_manager_inventory_link = /** @type {((inputs?: Dashboard_Manager_Inventory_LinkInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Manager_Inventory_LinkInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_manager_inventory_link(inputs)
});